"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VIDEO_NOTIFICATION_ACCESS_TYPE = exports.DEFAULT_DOMAIN = exports.SPACE_ROLES = exports.SPACE_INVITE_ROLES = exports.SPACE_DISCONNECT_TYPE = exports.SPACE_ACCEPT_REQUEST_TYPE = exports.SPACE_REQUEST_TYPE = exports.VIDEO_CALL_TYPE = exports.ADDITIONAL_META_TYPE = exports.NOTIFICATION_TYPE = exports.IDENTITY_TYPE = exports.SUPPORTED_CHAINS = exports.SOURCE_TYPES = exports.CHAIN_ID_TO_SOURCE = void 0;
exports.CHAIN_ID_TO_SOURCE = {
    1: 'ETH_MAINNET',
    11155111: 'ETH_TEST_SEPOLIA',
    137: 'POLYGON_MAINNET',
    80002: 'POLYGON_TEST_AMOY',
    56: 'BSC_MAINNET',
    97: 'BSC_TESTNET',
    10: 'OPTIMISM_MAINNET',
    11155420: 'OPTIMISM_TESTNET',
    2442: 'POLYGON_ZK_EVM_TESTNET',
    1101: 'POLYGON_ZK_EVM_MAINNET',
    421614: 'ARBITRUM_TESTNET',
    42161: 'ARBITRUMONE_MAINNET',
    122: 'FUSE_MAINNET',
    123: 'FUSE_TESTNET',
    80085: 'BERACHAIN_TESTNET',
    7560: 'CYBER_CONNECT_MAINNET',
    111557560: 'CYBER_CONNECT_TESTNET',
};
exports.SOURCE_TYPES = {
    ETH_MAINNET: 'ETH_MAINNET',
    ETH_TEST_SEPOLIA: 'ETH_TEST_SEPOLIA',
    POLYGON_MAINNET: 'POLYGON_MAINNET',
    POLYGON_TEST_AMOY: 'POLYGON_TEST_AMOY',
    BSC_MAINNET: 'BSC_MAINNET',
    BSC_TESTNET: 'BSC_TESTNET',
    OPTIMISM_MAINNET: 'OPTIMISM_MAINNET',
    OPTIMISM_TESTNET: 'OPTIMISM_TESTNET',
    POLYGON_ZK_EVM_TESTNET: 'POLYGON_ZK_EVM_TESTNET',
    POLYGON_ZK_EVM_MAINNET: 'POLYGON_ZK_EVM_MAINNET',
    ARBITRUM_TESTNET: 'ARBITRUM_TESTNET',
    ARBITRUMONE_MAINNET: 'ARBITRUMONE_MAINNET',
    FUSE_TESTNET: 'FUSE_TESTNET',
    FUSE_MAINNET: 'FUSE_MAINNET',
    BERACHAIN_TESTNET: 'BERACHAIN_TESTNET',
    THE_GRAPH: 'THE_GRAPH',
    PUSH_VIDEO: 'PUSH_VIDEO',
    SIMULATE: 'SIMULATE',
    CYBER_CONNECT_TESTNET: 'CYBER_CONNECT_TESTNET',
    CYBER_CONNECT_MAINNET: 'CYBER_CONNECT_MAINNET',
};
exports.SUPPORTED_CHAINS = [
    1, 11155111, 42, 137, 80002, 56, 97, 10, 11155420, 2442, 1101, 421614, 42161,
    122, 123, 80085, 111557560, 7560,
];
var IDENTITY_TYPE;
(function (IDENTITY_TYPE) {
    IDENTITY_TYPE[IDENTITY_TYPE["MINIMAL"] = 0] = "MINIMAL";
    IDENTITY_TYPE[IDENTITY_TYPE["IPFS"] = 1] = "IPFS";
    IDENTITY_TYPE[IDENTITY_TYPE["DIRECT_PAYLOAD"] = 2] = "DIRECT_PAYLOAD";
    IDENTITY_TYPE[IDENTITY_TYPE["SUBGRAPH"] = 3] = "SUBGRAPH";
})(IDENTITY_TYPE = exports.IDENTITY_TYPE || (exports.IDENTITY_TYPE = {}));
var NOTIFICATION_TYPE;
(function (NOTIFICATION_TYPE) {
    NOTIFICATION_TYPE[NOTIFICATION_TYPE["BROADCAST"] = 1] = "BROADCAST";
    NOTIFICATION_TYPE[NOTIFICATION_TYPE["TARGETTED"] = 3] = "TARGETTED";
    NOTIFICATION_TYPE[NOTIFICATION_TYPE["SUBSET"] = 4] = "SUBSET";
})(NOTIFICATION_TYPE = exports.NOTIFICATION_TYPE || (exports.NOTIFICATION_TYPE = {}));
var ADDITIONAL_META_TYPE;
(function (ADDITIONAL_META_TYPE) {
    ADDITIONAL_META_TYPE[ADDITIONAL_META_TYPE["CUSTOM"] = 0] = "CUSTOM";
    ADDITIONAL_META_TYPE[ADDITIONAL_META_TYPE["PUSH_VIDEO"] = 1] = "PUSH_VIDEO";
    ADDITIONAL_META_TYPE[ADDITIONAL_META_TYPE["PUSH_SPACE"] = 2] = "PUSH_SPACE";
})(ADDITIONAL_META_TYPE = exports.ADDITIONAL_META_TYPE || (exports.ADDITIONAL_META_TYPE = {}));
// Subset of ADDITIONAL_META_TYPE, to be used exclusively for Push Video, Spaces
var VIDEO_CALL_TYPE;
(function (VIDEO_CALL_TYPE) {
    VIDEO_CALL_TYPE[VIDEO_CALL_TYPE["PUSH_VIDEO"] = 1] = "PUSH_VIDEO";
    VIDEO_CALL_TYPE[VIDEO_CALL_TYPE["PUSH_SPACE"] = 2] = "PUSH_SPACE";
})(VIDEO_CALL_TYPE = exports.VIDEO_CALL_TYPE || (exports.VIDEO_CALL_TYPE = {}));
var SPACE_REQUEST_TYPE;
(function (SPACE_REQUEST_TYPE) {
    SPACE_REQUEST_TYPE[SPACE_REQUEST_TYPE["JOIN_SPEAKER"] = 0] = "JOIN_SPEAKER";
    SPACE_REQUEST_TYPE[SPACE_REQUEST_TYPE["ESTABLISH_MESH"] = 1] = "ESTABLISH_MESH";
    SPACE_REQUEST_TYPE[SPACE_REQUEST_TYPE["INVITE_TO_PROMOTE"] = 2] = "INVITE_TO_PROMOTE";
    SPACE_REQUEST_TYPE[SPACE_REQUEST_TYPE["REQUEST_TO_PROMOTE"] = 3] = "REQUEST_TO_PROMOTE";
})(SPACE_REQUEST_TYPE = exports.SPACE_REQUEST_TYPE || (exports.SPACE_REQUEST_TYPE = {}));
var SPACE_ACCEPT_REQUEST_TYPE;
(function (SPACE_ACCEPT_REQUEST_TYPE) {
    SPACE_ACCEPT_REQUEST_TYPE[SPACE_ACCEPT_REQUEST_TYPE["ACCEPT_JOIN_SPEAKER"] = 0] = "ACCEPT_JOIN_SPEAKER";
    SPACE_ACCEPT_REQUEST_TYPE[SPACE_ACCEPT_REQUEST_TYPE["ACCEPT_INVITE"] = 1] = "ACCEPT_INVITE";
    SPACE_ACCEPT_REQUEST_TYPE[SPACE_ACCEPT_REQUEST_TYPE["ACCEPT_PROMOTION"] = 2] = "ACCEPT_PROMOTION";
})(SPACE_ACCEPT_REQUEST_TYPE = exports.SPACE_ACCEPT_REQUEST_TYPE || (exports.SPACE_ACCEPT_REQUEST_TYPE = {}));
var SPACE_DISCONNECT_TYPE;
(function (SPACE_DISCONNECT_TYPE) {
    SPACE_DISCONNECT_TYPE[SPACE_DISCONNECT_TYPE["STOP"] = 0] = "STOP";
    SPACE_DISCONNECT_TYPE[SPACE_DISCONNECT_TYPE["LEAVE"] = 1] = "LEAVE";
})(SPACE_DISCONNECT_TYPE = exports.SPACE_DISCONNECT_TYPE || (exports.SPACE_DISCONNECT_TYPE = {}));
var SPACE_INVITE_ROLES;
(function (SPACE_INVITE_ROLES) {
    SPACE_INVITE_ROLES[SPACE_INVITE_ROLES["CO_HOST"] = 0] = "CO_HOST";
    SPACE_INVITE_ROLES[SPACE_INVITE_ROLES["SPEAKER"] = 1] = "SPEAKER";
})(SPACE_INVITE_ROLES = exports.SPACE_INVITE_ROLES || (exports.SPACE_INVITE_ROLES = {}));
var SPACE_ROLES;
(function (SPACE_ROLES) {
    SPACE_ROLES[SPACE_ROLES["HOST"] = 0] = "HOST";
    SPACE_ROLES[SPACE_ROLES["CO_HOST"] = 1] = "CO_HOST";
    SPACE_ROLES[SPACE_ROLES["SPEAKER"] = 2] = "SPEAKER";
    SPACE_ROLES[SPACE_ROLES["LISTENER"] = 3] = "LISTENER";
})(SPACE_ROLES = exports.SPACE_ROLES || (exports.SPACE_ROLES = {}));
exports.DEFAULT_DOMAIN = 'push.org';
var VIDEO_NOTIFICATION_ACCESS_TYPE;
(function (VIDEO_NOTIFICATION_ACCESS_TYPE) {
    VIDEO_NOTIFICATION_ACCESS_TYPE["PUSH_CHAT"] = "PUSH_CHAT";
})(VIDEO_NOTIFICATION_ACCESS_TYPE = exports.VIDEO_NOTIFICATION_ACCESS_TYPE || (exports.VIDEO_NOTIFICATION_ACCESS_TYPE = {}));
//# sourceMappingURL=constants.js.map